import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {MenuComponent} from "@/assets/ts/components";
import {setCurrentPageBreadcrumbs} from "@/core/helpers/breadcrumb";
import {onMounted, reactive, ref, watch} from "vue";
import {useStore} from "vuex";
import Summary from "./components/Summary.vue";
import Detail from "./components/Detail.vue";
import Filter from './components/ProductFilter.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const apiUrl = 'report/product';
const filters = reactive({
});
const loading = ref<boolean>(false);

onMounted(() => {
  MenuComponent.reinitialization();
  setCurrentPageBreadcrumbs("report.product.productDetails", ["report.product.name", "report.product.productName"]);
});

// 搜索动作
const searchAction = (filter) => {
  for (let k in filter) {
    filters[k] = filter[k];
  }
  loading.value = true;
  setTimeout(function() {
    loading.value = false;
  }, 500);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Filter, {
      onSearchAction: searchAction,
      selectionRecommendEnable: true
    }),
    _createVNode(Summary, {
      filters: _unref(filters),
      title: "汇总数据",
      apiUrl: apiUrl + '/summary',
      reportId: 4,
      loading: loading.value,
      exportToExcel: true
    }, null, 8, ["filters", "apiUrl", "loading"]),
    _createVNode(Detail, {
      filters: _unref(filters),
      title: "明细数据",
      apiUrl: apiUrl + '/details',
      reportId: 5,
      loading: loading.value
    }, null, 8, ["filters", "apiUrl", "loading"])
  ], 64))
}
}

})